<header class="header">
  <div class="bg-white">
    <div class="container">
      <div
        class="d-flex header__navbar justify-content-between align-items-center"
      >
        @if (!fromPartnerPortal()) {
        <div
          [tabindex]="isOnVerifyIdentityPage() ? '-1' : '0'"
          [attr.role]="isOnVerifyIdentityPage() ? null : 'button'"
          [attr.aria-label]="
            isOnVerifyIdentityPage()
              ? null
              : ('HOME_PAGE_LINK' | globalTranslate)
          "
          (click)="setLogoRedirectionUrl()"
          (keydown.enter)="setLogoRedirectionUrl()"
          (keydown.space)="setLogoRedirectionUrl(); $event.preventDefault()"
          [class.cursor-pointer]="!isOnVerifyIdentityPage()"
          class="text-center navbar-brand-wrapper d-flex align-items-top"
        >
          <a class="d-none d-lg-block navbar-brand brand-logo">
            <img
              alt=""
              src="assets/images/TCC-Logo_DESKTOP.png"
              class="brand-logo-desktop"
              aria-hidden="true"
            />
          </a>
        </div>
        } @if (fromPartnerPortal()) {
        <div class="text-center navbar-brand-wrapper d-flex align-items-top">
          <div class="d-none d-lg-block navbar-brand brand-logo">
            @if (fromPartnerPortal()) {
            <img
              alt=""
              src="assets/images/TCC-Logo_DESKTOP.png"
              class="brand-logo-desktop"
              aria-hidden="true"
            />
            }
          </div>
        </div>
        }
        <div
          class="cursor-pointer text-center navbar-brand-wrapper d-flex align-items-top"
        >
          <a class="d-block d-lg-none navbar-brand brand-logo">
            @if (!fromPartnerPortal()) {
            <img
              alt=""
              src="assets/images/TCC-Logo_MOBILE.png"
              class="brand-logo-mobile"
              aria-hidden="true"
            />
            } @if (fromPartnerPortal()) {
            <img
              alt=""
              src="assets/images/TCC-Logo_DESKTOP.png"
              class="brand-logo-mobile"
              aria-hidden="true"
            />
            }
          </a>
        </div>
        <div class="d-lg-none signin-clustor">
          @if (this.show && !isLoggedIn() && !mobileUser()) {
          <div class="signin-btn">
            <button (click)="navigateToSignIn()" class="button btn btn-primary">
              {{ "SIGNIN" | globalTranslate }}
            </button>
          </div>
          }
          <!-- Hamburger Icon -->
          @if (isLoggedIn()) {
          <div class="profile-icon">
            <img class="" alt="" src="assets/images/profile.svg" />
          </div>
          }
          <div
            tabindex="0"
            role="button"
            [attr.aria-label]="
              (
                showTutorialInMobileView
                  ? !dropdownOpened && !joyrideService.isTourInProgress()
                  : !dropdownOpened
              )
                ? ('EXPAND_NAVIGATION_MENU' | globalTranslate)
                : ('CLOSE_NAVIGATION_MENU' | globalTranslate)
            "
            [attr.aria-expanded]="
              showTutorialInMobileView
                ? dropdownOpened || joyrideService.isTourInProgress()
                : dropdownOpened
            "
            (click)="onOpen($event)"
            class="float-end d-lg-none text-primary hamurber"
          >
            @if (showTutorialInMobileView ? !dropdownOpened &&
            !joyrideService.isTourInProgress() : !dropdownOpened) {
            <span class="menu-icon"
              ><img
                alt=""
                aria-hidden="true"
                src="assets/images/close-menu.svg"
            /></span>
            } @if (showTutorialInMobileView ? dropdownOpened ||
            joyrideService.isTourInProgress() : dropdownOpened) {
            <span class="close-icon"
              ><img
                alt=""
                aria-hidden="true"
                src="assets/images/navigation-menu.svg"
            /></span>
            }
          </div>
        </div>

        <nav
          [attr.aria-label]="'PRIMARY_NAVIGATION' | globalTranslate"
          class="d-none d-lg-block header__navbar--links text-end"
        >
          <ul class="list-unstyled d-inline-flex align-items-center mb-0">
            <li
              joyrideStep="Step5"
              text="{{ 'TUTORIAL_5' | globalTranslate }}"
              class="me-4 hover"
            >
              @if (!mobileUser()) {
              <a
                tabindex="0"
                (click)="navigateToFAQ($event)"
                [attr.aria-label]="
                  'FREQUENTLY_ASKED_QUESTIONS' | globalTranslate
                "
                class="cursor-pointer"
                >{{ "FAQS" | globalTranslate }}</a
              >
              } @if (mobileUser()) {
              <a
                (click)="openFAQPopUp()"
                [attr.aria-label]="
                  'FREQUENTLY_ASKED_QUESTIONS' | globalTranslate
                "
                >{{ "FAQS" | globalTranslate }}</a
              >
              }
            </li>
            @if (!mobileUser()) {
            <li class="divider" aria-hidden="true"></li>
            } @if (!isLoggedIn() || !fromPartnerPortal()) {
            <li class="ms-2 me-2 hover d-flex align-items-center">
              <img
                class="me-2"
                alt=""
                src="assets/images/translate.png"
                aria-hidden="true"
                [class.cursor-pointer]="awsTranslateSwitch"
                (click)="awsTranslateSwitch ? openTranslateWidget() : null"
              />
              <a
                tabindex="0"
                role="button"
                class="translate-link"
                (click)="
                  awsTranslateSwitch ? openTranslateWidget() : setLanguage()
                "
                >{{ "TRANSLATE" | globalTranslate }}</a
              >
            </li>
            } @if (this.show && !isLoggedIn() && !mobileUser()) {
            <li>
              <button [routerLink]="['/signin']" class="btn btn-primary">
                {{ "SIGNIN" | globalTranslate }}
              </button>
            </li>
            } @if (isLoggedIn() && !fromPartnerPortal()) {
            <li class="divider" aria-hidden="true"></li>
            } @if (isLoggedIn() && !fromPartnerPortal() && !this.isKepro) {
            <li (click)="toggleProfile()" class="dropdown cursor-pointer ms-4">
              @if (dropdownOpened) {
              <svg
                id="_icons_person-circle-outline"
                data-name="⚛️ icons/person-circle-outline"
                xmlns="http://www.w3.org/2000/svg"
                width="35"
                height="35"
                viewBox="0 0 48 48"
              >
                <path
                  id="Combined_Shape"
                  data-name="Combined Shape"
                  d="M19.229,39A19.491,19.491,0,0,1,5.627,5.814,19.36,19.36,0,0,1,19.507,0c.088,0,.176,0,.266,0a19.494,19.494,0,0,1,13.606,33.19A19.362,19.362,0,0,1,19.5,39C19.411,39,19.319,39,19.229,39Zm8.788-11.126a11.636,11.636,0,0,1,3.033,2.776.373.373,0,0,0,.281.149h.018a.373.373,0,0,0,.277-.121A16.491,16.491,0,0,0,19.5,3h-.043A16.489,16.489,0,0,0,7.378,30.681a.372.372,0,0,0,.272.119h.023a.37.37,0,0,0,.281-.149,11.6,11.6,0,0,1,3.033-2.774A15.908,15.908,0,0,1,19.5,25.5,15.91,15.91,0,0,1,28.017,27.877ZM13.147,15.822a6.378,6.378,0,1,1,12.71,0C25.58,19.5,22.734,22.5,19.5,22.5S13.419,19.5,13.147,15.822Z"
                  transform="translate(4.498 4.498)"
                  fill="#132742"
                />
              </svg>
              } @if (!dropdownOpened) {
              <svg
                id="_icons_person-circle-outline"
                data-name="⚛️ icons/person-circle-outline"
                xmlns="http://www.w3.org/2000/svg"
                width="35"
                height="35"
                viewBox="0 0 48 48"
              >
                <path
                  id="Combined_Shapes"
                  data-name="Combined Shape"
                  d="M19.229,39A19.491,19.491,0,0,1,5.627,5.814,19.36,19.36,0,0,1,19.507,0c.088,0,.176,0,.266,0a19.494,19.494,0,0,1,13.606,33.19A19.362,19.362,0,0,1,19.5,39C19.411,39,19.319,39,19.229,39Zm8.788-11.126a11.636,11.636,0,0,1,3.033,2.776.373.373,0,0,0,.281.149h.018a.373.373,0,0,0,.277-.121A16.491,16.491,0,0,0,19.5,3h-.043A16.489,16.489,0,0,0,7.378,30.681a.372.372,0,0,0,.272.119h.023a.37.37,0,0,0,.281-.149,11.6,11.6,0,0,1,3.033-2.774A15.908,15.908,0,0,1,19.5,25.5,15.91,15.91,0,0,1,28.017,27.877ZM13.147,15.822a6.378,6.378,0,1,1,12.71,0C25.58,19.5,22.734,22.5,19.5,22.5S13.419,19.5,13.147,15.822Z"
                  transform="translate(4.498 4.498)"
                  fill="#174A7C"
                />
              </svg>
              } @if (dropdownOpened) {
              <span tabindex="0" class="person-style-opened">
                {{ "WELCOME_1" | globalTranslate }},
                {{ userDetails?.firstName }} {{ userDetails?.lastName }}</span
              >
              } @if (!dropdownOpened) {
              <span tabindex="0" class="person-style-closed">
                {{ "WELCOME_1" | globalTranslate }},
                {{ userDetails?.firstName }} {{ userDetails?.lastName }}</span
              >
              } @if (!dropdownOpened && !mobileUser() &&
              !isOnVerifyIdentityPage()) {
              <img
                class="ml-2 me-2"
                alt="down"
                src="../../../assets/images/⚛️ icons-menu-collapsed-arrow.svg"
                aria-hidden="true"
              />
              } @if (dropdownOpened) {
              <img
                class="ml-2 me-2"
                alt="up"
                src="../../../assets/images/⚛️ icons-menu-expanded-arrow.svg"
                aria-hidden="true"
              />
              }
            </li>
            } @if (isLoggedIn() && fromPartnerPortal()) {
            <li class="ms-4">
              <svg
                id="_icons_person-circle-outline"
                data-name="⚛️ icons/person-circle-outline"
                xmlns="http://www.w3.org/2000/svg"
                width="35"
                height="35"
                viewBox="0 0 48 48"
              >
                <path
                  id="Combined_Shape"
                  data-name="Combined Shape"
                  d="M19.229,39A19.491,19.491,0,0,1,5.627,5.814,19.36,19.36,0,0,1,19.507,0c.088,0,.176,0,.266,0a19.494,19.494,0,0,1,13.606,33.19A19.362,19.362,0,0,1,19.5,39C19.411,39,19.319,39,19.229,39Zm8.788-11.126a11.636,11.636,0,0,1,3.033,2.776.373.373,0,0,0,.281.149h.018a.373.373,0,0,0,.277-.121A16.491,16.491,0,0,0,19.5,3h-.043A16.489,16.489,0,0,0,7.378,30.681a.372.372,0,0,0,.272.119h.023a.37.37,0,0,0,.281-.149,11.6,11.6,0,0,1,3.033-2.774A15.908,15.908,0,0,1,19.5,25.5,15.91,15.91,0,0,1,28.017,27.877ZM13.147,15.822a6.378,6.378,0,1,1,12.71,0C25.58,19.5,22.734,22.5,19.5,22.5S13.419,19.5,13.147,15.822Z"
                  transform="translate(4.498 4.498)"
                  fill="#174A7C"
                />
              </svg>
              <span class="person-style-closed cursor-type">
                {{ "WELCOME_1" | globalTranslate }}
                {{ pPUserDetails?.firstName }}
                {{ pPUserDetails?.lastName }}</span
              >
            </li>
            } @if (isLoggedIn() && !this.isKepro && !mobileUser() &&
            !isAhsRidpFlow()) {
            <li class="logout-desktop">
              <button
                (click)="onSignout($event)"
                id="log-out-web"
                type="button"
                class="btn btn-secondary text-center"
                [ngClass]="{
                  'width-translate': increaseWidth(),
                  'font-translate': decreaseFont(),
                  'width-extra': extraWidth()
                }"
              >
                {{ "LOGOUT" | globalTranslate }}
              </button>
            </li>
            }
          </ul>
        </nav>
      </div>
    </div>
  </div>
  <!-- <nh-id-bar></nh-id-bar> -->
  @if (showTutorialInMobileView ? dropdownOpened ||
  joyrideService.isTourInProgress() : dropdownOpened) {
  <div class="bg-white desktop-menu-list">
    @if (isLoggedIn()) {
    <div class="container mainnav padding-none">
      <div class="mobile-translate mobile-profile-name">
        <img class="me-2" alt="logo" src="assets/images/profile.svg" />
        @if (!fromPartnerPortal() && !mobileUser()) {
        <span class="hover fw-700"
          >{{ "WELCOME_1" | globalTranslate }}, {{ userDetails?.firstName }}
          {{ userDetails?.lastName }}</span
        >
        } @if (!fromPartnerPortal() && mobileUser()) {
        <span class="mobApp fw-700"
          >{{ "WELCOME_1" | globalTranslate }}, {{ userDetails?.firstName }}
          {{ userDetails?.lastName }}</span
        >
        } @if (fromPartnerPortal()) {
        <span class="hover fw-700"
          >{{ "WELCOME_1" | globalTranslate }} {{ pPUserDetails?.firstName }}
          {{ pPUserDetails?.lastName }}</span
        >
        }
      </div>
      @if (!fromPartnerPortal() && !mobileUser()) {
      <ul class="hover-options">
        <li class="hover">
          <span tabindex="0" (click)="navigateToManageAccount()">
            {{ "MANAGE_MY" | globalTranslate }}
          </span>
        </li>
      </ul>
      }
      <ul class="mobile-translate">
        <li>
          <span
            joyrideStep="Step9"
            text="{{ 'TUTORIAL_5' | globalTranslate }}"
            class="me-5 hover"
          >
            @if (!mobileUser()) {
            <a
              tabindex="0"
              (click)="navigateToFAQ($event)"
              title="FAQs"
              [attr.aria-label]="'FREQUENTLY_ASKED_QUESTIONS' | globalTranslate"
              class="cursor-pointer"
              >{{ "FAQS" | globalTranslate }}</a
            >
            } @if (mobileUser()) {
            <a
              (click)="openFAQPopUp()"
              [attr.aria-label]="'FREQUENTLY_ASKED_QUESTIONS' | globalTranslate"
              >{{ "FAQS" | globalTranslate }}</a
            >
            }
          </span>
        </li>
      </ul>
      @if (!isLoggedIn() || !fromPartnerPortal()) {
      <ul class="mobile-translate">
        <li>
          <span class="hover">
            <img
              class="me-2"
              alt=""
              aria-hidden="true"
              src="assets/images/translate.png"
              [class.cursor-pointer]="awsTranslateSwitch"
              (click)="awsTranslateSwitch ? openTranslateWidget() : null"
            />
            <a
              tabindex="0"
              role="button"
              (click)="
                awsTranslateSwitch ? openTranslateWidget() : setLanguage()
              "
              >{{ "TRANSLATE" | globalTranslate }}</a
            >
          </span>
        </li>
        <hr />
      </ul>
      } @if (isLoggedIn() && !this.isKepro && !mobileUser()) {
      <div class="pe-4 d-flex justify-content-end logout-mobile">
        <button
          (click)="onSignout($event)"
          id="log-out"
          type="button"
          class="btn btn-secondary text-center"
          [ngClass]="{
            'width-translate': increaseWidth(),
            'font-translate': decreaseFont(),
            'width-extra': extraWidth()
          }"
        >
          {{ "LOGOUT" | globalTranslate }}
        </button>
      </div>
      }
    </div>
    } @if (!isLoggedIn()) {
    <div class="container">
      <ul class="mobile-translate">
        <li class="hover cursor-pointer">
          @if (!mobileUser()) {
          <a
            tabindex="0" 
            (click)="navigateToFAQ($event)"
            [attr.aria-label]="'FREQUENTLY_ASKED_QUESTIONS' | globalTranslate"
            class="cursor-pointer"
            >{{ "FAQS" | globalTranslate }}</a
          >
          } @if (mobileUser()) {
          <a
            (click)="openFAQPopUp()"
            [attr.aria-label]="'FREQUENTLY_ASKED_QUESTIONS' | globalTranslate"
            >{{ "FAQS" | globalTranslate }}</a
          >
          }
        </li>
        <hr />
        @if (!isLoggedIn() || !fromPartnerPortal()) {
        <li class="hover cursor-pointer">
          <img
            alt=""
            aria-hidden="true"
            src="assets/images/translate.png"
            [class.cursor-pointer]="awsTranslateSwitch"
            (click)="awsTranslateSwitch ? openTranslateWidget() : null"
          />
          <a
            tabindex="0"
            role="button"
            (click)="awsTranslateSwitch ? openTranslateWidget() : setLanguage()"
            >{{ "TRANSLATE" | globalTranslate }}</a
          >
        </li>
        }
      </ul>
      <hr />
      @if (isLoggedIn() && !mobileUser()) {
      <div class="m-3 d-flex justify-content-end">
        <button
          (click)="onSignout($event)"
          type="button"
          class="btn btn-outline-danger mb-10"
        >
          {{ "SIGNOUT" | globalTranslate }}
        </button>
      </div>
      }
    </div>
    }
  </div>
  }
</header>